const LoadBar = () => {
  return (
    <div className="load-bar">
      <div className="bar" />
      <div className="bar" />
      <div className="bar" />
    </div>
  )
}

export default LoadBar
